export default function AJAX_XMLFile() {
  return (
    <div>
      <h1>AJAX_XMLFile</h1>
      <p>This is the AJAX_XMLFile component.</p>
    </div>
  );
}